import React from 'react';

export const RESOLUTIONS = [
    {key: 'hw5', media: '(min-width: 1920px)'}, // Desktop Large HD
    {key: 'hw4', media: '(min-width: 1440px) and (max-width: 1919px)'}, // Desktop Medium
    {key: 'hw1', media: '(min-width: 1280px) and (max-width: 1439px)'}, // Desktop Small
    {key: 'hw2', media: '(min-width: 480px) and (max-width: 1279px)'}, // Tablet
    {key: 'hw6', media: '(max-width: 479px)'} // Mobile
];

export function HeroImage({urlTemplate, altText, defaultImage}) {
    const isIE11 =
        typeof window !== 'undefined' &&
        !!window.navigator.userAgent.match(/Trident\/7\./);

    if (!urlTemplate) {
        return (
            <picture className="hero-image">
                {isIE11 ? (
                    <svg className="hero-image__img">
                        <image
                            xlinkHref={defaultImage}
                            width="1024"
                            height="768"
                        />
                    </svg>
                ) : (
                    <img
                        className="hero-image__img"
                        src={defaultImage}
                        alt={altText}
                    />
                )}
                <div className="hero-image__overlay" />
            </picture>
        );
    }

    const sources = RESOLUTIONS.map(({key, media}) => ({
        key,
        media,
        srcSet: urlTemplate.replace('${templateId}', key)
    }));

    return (
        <picture className="hero-image">
            {sources.map((props) => <source {...props} />)}
            <img
                className="hero-image__img"
                src={sources[0].srcSet}
                alt={altText}
            />
        </picture>
    );
}
